export const titleBarStyle = { justifyContent: 'space-between', margin: 0 };
